module.exports = __webpack_public_path__ + "static/media/wheel-center.d8700983.png";